export default __webpack_public_path__ + "static/media/hearth.da4e641d.png";